import React from 'react';
import PropTypes from 'prop-types';
import { compose, branch, renderNothing, pure, withHandlers } from 'recompose';
import { getFile } from '../../../utils/resources';

import {
  StyledText,
  StyledTextWeekly,
  StyledIcon,
  StyledButtonWeek,
  StyledButtonLight,
  StyledBoxButtons
} from './style';

import {
  StyledObjetive,
  StyledObjetiveWeekly,
  StyledObjetiveList,
  StyledObjetiveListWeekly,
  ItemObjetiveList,
  StyledObjetiveType,
  StyledObjetiveTypeWeekly,
  StyledObjetiveFood,
  StyledObjetiveFoodWeekly,
  StyledObjetiveIcons,
  StyledObjetiveIconsWeekly
} from './styleMenuObjective';

import Icon from '../../core/Icon';
import {
  Wellness,
  WellnessText,
  Download
} from '../../../../assets/images/index';
import { HEALTHY_GUIDE_URL } from '../../../constants/api';

/** Utils */
import { navigateToFile } from '../../../utils/navigate';

const MenuObjetive = ({ menu, weekly, downloadContent, wellnessMenuUrl }) => {
  const Objetive = weekly ? StyledObjetiveWeekly : StyledObjetive;
  const ObjetiveIcons = weekly
    ? StyledObjetiveIconsWeekly
    : StyledObjetiveIcons;
  const ObjetiveList = weekly ? StyledObjetiveListWeekly : StyledObjetiveList;
  const ObjetiveType = weekly ? StyledObjetiveTypeWeekly : StyledObjetiveType;
  const ObjetiveFood = weekly ? StyledObjetiveFoodWeekly : StyledObjetiveFood;
  const Text = weekly ? StyledTextWeekly : StyledText;

  return (
    <Objetive>
      <ObjetiveIcons>
        <StyledIcon size="l" svg={Wellness} />
        <Text size="l" svg={WellnessText} />
      </ObjetiveIcons>
      <ObjetiveList>
        {menu.map(item => (
          <ItemObjetiveList key={item.title}>
            <ObjetiveType>{item.title}</ObjetiveType>
            {item.dishes.map(dish => (
              <ObjetiveFood key={dish.name}>{dish.name}</ObjetiveFood>
            ))}
          </ItemObjetiveList>
        ))}
      </ObjetiveList>
      {weekly && (
        <StyledBoxButtons>
          <StyledButtonWeek
            onClick={() => downloadContent(getFile(wellnessMenuUrl))}
          >
            <Icon color="light" size="m" svg={Download} />
            menú semanal
          </StyledButtonWeek>
          <StyledButtonLight onClick={() => downloadContent(HEALTHY_GUIDE_URL)}>
            <Icon color="light" size="m" svg={Download} />
            guía saludable
          </StyledButtonLight>
        </StyledBoxButtons>
      )}
    </Objetive>
  );
};

MenuObjetive.propTypes = {
  menu: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      dishes: PropTypes.arrayOf(
        PropTypes.shape({ id: PropTypes.string, name: PropTypes.string })
      )
    })
  ),
  downloadContent: PropTypes.func,
  wellnessMenuUrl: PropTypes.string,
  weekly: PropTypes.bool
};

export default compose(
  branch(({ menu }) => !menu, renderNothing),
  withHandlers({
    downloadContent: () => url => {
      if (url) {
        navigateToFile(url);
      }
    }
  }),
  pure
)(MenuObjetive);
